import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../AuthContext';
import { db } from '../../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './TrackPurchases.css';

const TrackPurchases = () => {
    const [pendingContent, setPendingContent] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        const fetchPendingContent = async () => {
            if (!user) return;

            try {
                const requestsRef = collection(db, 'custom_content_requests');
                const q = query(
                    requestsRef,
                    where('userId', '==', user.uid),
                    where('status', 'in', ['paid', 'fulfilled'])
                );

                const querySnapshot = await getDocs(q);
                const pendingItems = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setPendingContent(pendingItems);
            } catch (error) {
                console.error('Error fetching pending content:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPendingContent();
    }, [user]);

    if (loading) {
        return (
            <div className="track-purchases">
                <h3>Track My Purchases</h3>
                <div className="loading-spinner"></div>
            </div>
        );
    }

    if (pendingContent.length === 0) {
        return (
            <div className="track-purchases">
                <h3>Track My Purchases</h3>
                <div className="empty-message">
                    <p>You haven't purchased any custom content yet.</p>
                    <p>Check out the Request Portal to request something special!</p>
                </div>
            </div>
        );
    }

    return (
        <div className="track-purchases">
            <h3>Track My Purchases</h3>
            
            <div className="content-grid">
                {pendingContent.map(item => (
                    <div key={item.id} className="pending-content-card">
                        <div className={`status-badge ${item.status}`}>
                            {item.status === 'fulfilled' ? 'Completed' : 'Processing'}
                        </div>
                        <div className="card-content">
                            <h4>Request #{item.requestNumber || 'N/A'}</h4>
                            <div className="order-details">
                                <div className="detail-row">
                                    <span className="label">Top:</span>
                                    <span className="value">{item.topOutfitLabel}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="label">Bottom:</span>
                                    <span className="value">{item.outfitLabel}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="label">Pose:</span>
                                    <span className="value">{item.poseLabel}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="label">Request #:</span>
                                    <span className="value">{item.requestNumber}</span>
                                </div>
                                <div className="detail-row">
                                    <span className="label">Status:</span>
                                    <span className={`value status-${item.status}`}>
                                        {item.status === 'fulfilled' ? 'Fulfilled' : 'Pending'}
                                    </span>
                                </div>
                            </div>
                            <div className={`delivery-info ${item.status}`}>
                                {item.status === 'fulfilled' ? (
                                    <div className="fulfilled-info">
                                        <p>Your content is ready!</p>
                                        <p className="view-note">View your content in the "Purchased Content" tab</p>
                                    </div>
                                ) : (
                                    <div className="estimated-delivery">
                                        <p>Your content will be ready within 24 hours</p>
                                        <p className="delivery-note">You'll receive a notification when it's ready!</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TrackPurchases;
